export enum FilterDisplayName {
  brands = 'brands',
  categories = 'categories',
  capacities = 'capacities',
  domains = 'domains',
}
